'use strict'

import format from 'string-format'

export class File {
	constructor(parent, data) {
		this._parent = parent
		this._name = data.name
		this._path = data.path
	}

	get parent() {
		return this._parent
	}

	get name() {
		return this._name
	}

	get path() {
		// const parent_path = this.parent ? this.parent.path : ''
		// return format("{0}/{1}", parent_path, this.name)
		return this._path
	}

	icon_name(selected, open) {
		return 'mdi-file-document-outline'
	}
}

export class Folder extends File {
	constructor(parent, data) {
		super(parent, data)

		this.children = data.children
			.map(
				function (child_data) {
					return child_data.type === 'file' ? new File(this, child_data) :
						child_data.type === 'folder' ? new Folder(this, child_data) :
							null
				}.bind(this)
			).sort(
				function (c1, c2) {
					const c1_c = c1.constructor
					const c2_c = c2.constructor

					if (c1_c === Folder && c2_c === File) {
						return -1
					} else if (c1_c === File && c2_c === Folder) {
						return +1
					} else if (
						(c1_c === File && c2_c === File) ||
						(c1_c === Folder && c2_c === Folder)) {
						return c1.name.localeCompare(c2.name)
					} else {
						console.warn(format(
							"Unexpected comparison '{0}' with '{1}'.",
							format("{type}:{name}", typeof (c1), c1.name),
							format("{type}:{name}", typeof (c2), c2.name)
						))
						return 0
					}
				})
	}

	icon_name(selected, open) {
		return open ? 'mdi-folder-open' : 'mdi-folder'
	}
}

export class Storage {
	constructor(data, dispatch) {
		this.id = data.id
		this.name = data.name

		this._dispatch = dispatch

		this._tree = null
		this._tree_loading = false
		this._tree_loaded = false
	}

	get tree() {
		if (this._tree == null && !this._tree_loading) {
			console.debug(format(
				"Storage '{0}' tree loading ...", this.name))

			const storage = this
			this._dispatch('load_tree', {storage})
				.then(function (val) {

				})
		}

		return this._tree
	}

	// -- loading --
	get tree_loaded() {
		return this._tree_loaded
	}

	tree_load_begin() {
		this._tree_loading = true
	}

	tree_load_end() {
		this._tree_loading = false
	}

	set_tree(tree_data) {
		// root folder
		if (tree_data === null) {
			this._tree = null
		} else if (tree_data.type == 'error') {
			throw new Error(format(
				"Failed to get storage tree on server: {0}", tree_data.message))
		} else {
			this._tree = new Folder(null, tree_data)
		}
		this._tree_loaded = true
	}
}